import * as React from 'react';
import { useEffect, useState } from 'react';
import wrapStore from '@src/utils/wrap-store';
import FooterStore from './store';
import styles from './index.less';
import aos from '@src/utils/aos';
import cx from 'classnames';
// import SilentVideo from '@src/components/silent-video';
const FooterPage = ({ store }) => {
  store.use();
  aos.reInit();
  
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isVisible) {
            setIsVisible(true);
            observer.disconnect(); // 一旦显示就停止观察
          }
        }
      },
      {
        threshold: 0.6 // 当10%的元素可见时触发
      }
    );

    const element = document.getElementById('footer');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={cx(styles.root, 'section',{ [styles.visibleRoot]: isVisible })} id="footer">
      <div className={styles.hint} >
        <div className={styles.title}>反腐倡廉</div>
        <div className={styles.content}> 
          {store.msg}
        </div>
      </div>
      <div className={styles.rightB} />
    </div>
  );
};

export default wrapStore(FooterPage, FooterStore);
